module.exports = __webpack_public_path__ + "static/img/bottom-d-right.a0b1cb58.png";